<template>
  <div v-if="ranks !== null && Object.values(ranks.Phases).length > 0">
    <div class="title mb-3">CLASSIFICA</div>
    <b-container class="m-4"
                 v-show="availablePhases.length > 1 || availableSessions.length > 1 || availableRanksets.length > 1">
      <b-row class="header text-center">
        <b-col><!--***-->Fase</b-col>
        <b-col><!--***-->Sessione</b-col>
        <b-col><!--***-->Gironi</b-col>
      </b-row>
      <b-row class="text-center">
        <b-col>
          <combo-or-label v-model="phase" :options="availablePhases"></combo-or-label>
        </b-col>
        <b-col>
          <combo-or-label v-model="session" :options="availableSessions"></combo-or-label>
        </b-col>
        <b-col>
          <combo-or-label v-model="rankSet" :options="availableRanksets"></combo-or-label>
        </b-col>
      </b-row>
    </b-container>


    <div v-if="simultaneousType === 2" class="mt-5 mb-3 text-center">
      <div class="rankTitle">CLASSIFICA NAZIONALE IN TEMPO REALE</div>
      <div class="rankAlert">Per potenziale mancanza di altri gironi non connessi ad internet, la seguente classifica è
        da considerarsi indicativa e non definitiva.<br>
        Per qualsiasi differenza con la classifica sul sito federale, fa fede quest'ultima
      </div>
    </div>


    <b-tabs class="rank">
      <b-tab v-for="(rank, rankIndex) in ranksToBeShown" :key="rankIndex"
             :title="rank.RankType === 0 ? 'Classifica di sessione' : 'Classifica cumulata'">
        <template v-for="(rankRow, rowIndex) in rank.Rank">
          <b-table :fields="fieldsToBeShown" :items="rankRow" class="figbHeader" :key="rankIndex * 10000 + rowIndex">
            <template #cell(index)="data">
              {{ data.index + 1 }}
            </template>
            <template #cell(FullName)="data">
              <span v-html="data.value"></span>
            </template>
          </b-table>
        </template>
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import {mapGetters} from 'vuex';
import ComboOrLabel from "@/components/lib/ComboOrLabel";

export default {
  name: 'Ranks',
  components: {ComboOrLabel},
  data() {
    return {
      phase: 1,
      session: 1,
      rankSet: 1
    }
  },
  computed: {
    ...mapGetters({
      globalDeals: 'deals/played',
      ranks: 'ranks/pairRanks',
      pairId: 'tournament/pairId',
      simultaneousType: 'tournament/simultaneousType'
    }),
    availablePhases() {
      return Object.keys(this.ranks?.Phases ?? {})
          .map(n => parseInt(n)).sort((a, b) => a - b);
    },
    availableSessions() {
      return Object.keys(
          this.ranks?.Phases[this.phase]?.Sessions ?? {}
      )
          .map(n => parseInt(n))
          .sort((a, b) => a - b);
    },
    availableRanksets() {
      return Object.keys(
          this.ranks
              ?.Phases[this.phase]
              ?.Sessions[this.session]
              ?.Ranksets ?? {}
      )
          .map(rkset => {
        return {
          value: rkset,
          text: this.globalDeals
              ?.Phases[this.phase]
              ?.Sessions[this.session]
              ?.Ranksets[rkset]
              ?.GroupedSectors.join('-') ?? 'Unica'
        }
      }).sort((a, b) => a.value - b.value);
    },
    ranksToBeShown() {
      const that = this;
      let ret = this.ranks
          ?.Phases[this.phase]
          ?.Sessions[this.session]
          ?.Ranksets[this.rankSet]
          ?.Ranks ?? null
      if (ret === null) {
        return []
      }


      if (this.session === 1 && that.phase === 1 && ret.length > 1) {
        //In case of first session, remove "session" rank, useless...
        ret = ret.filter(rnk => rnk.RankType === 1);
      }

      if (ret === undefined) {
        return [];
      }

      ret.forEach(rnk => {
        rnk.Rank.forEach(rn => {
          const found = rn.find(row => row.PairId === that.pairId)
          if (found !== undefined) {
            found._rowVariant = "warning";
          }
        });
      });
      return ret;
    },
    fieldsToBeShown() {
      return [
        {
          key: 'index',
          label: ''
        }, {
          key: 'FullName',
          label: this.$t('scoreViewer.pairName'),
          formatter: val => val.replace(" - ", "<br>")
        },
        {
          key: 'MP',
          label: 'MP'
        },
        {
          key: 'Percentage',
          label: this.$t('scoreViewer.percentage')
        },
        {
          key: 'PlayedBoards',
          label: this.$t('scoreViewer.board')
        }
      ];
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.phase = Math.max(...this.availablePhases);
        this.$nextTick(() => {
          this.session = Math.max(...this.availableSessions);
        });
    });
  }
};
</script>

<style scoped>
.header {
  font-weight: bold;
}

.rankTitle {
  font-size: 2rem;
  font-weight: bold;
}

.rankAlert {
  font-size: 1rem;
  color: red;
}

/*La scheda "Classifica di X/Y" diventa blu quando NON selezionata...che schifo!*/
>>> .nav-link {
  color: black;
  font-weight: bold;
}

.title {
  width: 100%;
  margin: 0 auto;
  text-align: center;
  color: #3396B8;
}


>>> .rank .nav-link {
  background-color: white;
  color: #AAAAAA;
  border-top-right-radius: 10px !important;
}


>>> .active {
  color: #1B708D !important;
}


>>> .figbHeader thead {
  color: #3396B8;
  background-color: white;
}
</style>
